import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
} from '@angular/core';

/** Parent widget root (.lead-capture-v2-widget / .tour-booking-widget) must be `position: relative`. */
@Component({
  standalone: true,
  selector: 'ufp-widget-processing-overlay',
  encapsulation: ViewEncapsulation.None,
  template: `
    @if (visible()) {
      <div
        class="widget-processing-overlay"
        role="status"
        aria-live="polite"
        [attr.aria-label]="message()"
      >
        <div class="widget-processing-spinner" aria-hidden="true"></div>
        <p>{{ message() }}</p>
      </div>
    }
  `,
  styleUrls: ['../../styles/widget-submit-ui.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetProcessingOverlayComponent {
  readonly visible = input(false);
  readonly message = input('Processing...');
}
